import { render, staticRenderFns } from "./listOwner.vue?vue&type=template&id=48215946&scoped=true"
import script from "./listOwner.vue?vue&type=script&lang=js"
export * from "./listOwner.vue?vue&type=script&lang=js"
import style0 from "./listOwner.vue?vue&type=style&index=0&id=48215946&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48215946",
  null
  
)

export default component.exports